import { ROLES as R } from "../core/roles";
import { lud, only, rule } from "../core/rule";
import { SCOPES } from "../core/scope";

export const onboardingPermissions = {
  view: "onboarding.view",
  ticket: { delete: "onboarding.ticket.delete", analytics: "onboarding.ticket.analytics" },
  // /auth/store-onboarding: the new-client wizard (ceo can open it too)
  store: { view: "onboarding.store.view" },
  // Store-based onboarding inside the dashboard (Phase 3): the client's OWN store (draft or not) - its completion, profile data,
  // documents and draft branches. Backend: /store-onboarding/stores/:storeId/*
  draft: { view: "onboarding.draft.view", edit: "onboarding.draft.edit" },
};

export const onboardingGrants = {
  "onboarding.view": rule(lud(R.FA, R.DM, R.DMM, R.AM, R.MENU_SP)),
  // ceo-level and dmm (approved, NA-009); the ticket's restaurant must be in scope
  "onboarding.ticket.delete": rule(lud(R.DMM), { scope: SCOPES.RESTAURANT }),
  // ticket message chart is only loaded / shown for ceo-level
  "onboarding.ticket.analytics": rule(lud()),
  // Client onboarding wizard (NA-015): ceo-level, `new`, and clients resuming
  // their own onboarding. The wizard has no restaurant parameter - the API
  // always returns the signed-in user's own record - so a client must hold at
  // least one authorized restaurant (`between`) to enter. Not the
  // administrative store-onboarding management (storeOnboardingAdmin.*).
  "onboarding.store.view": rule(only(R.CEO, R.CTO, R.DEVELOPER, R.NEW, R.STORE, R.STORE_L), {
    when: ({ role, user }) =>
      ![R.STORE, R.STORE_L].includes(role) || (user?.between || []).length > 0,
  }),
  // Store-based onboarding (Phase 3). Reading and editing are limited to the caller's own store (scope: restaurant); whether the data
  // is still editable depends on the store's onboarding status (new / inProgress / rejected), decided by the server. Not billing, not
  // applications, not branch activation: those permissions stay with the roles that already hold them.
  "onboarding.draft.view": rule(lud(R.NEW, R.STORE, R.STORE_L), { scope: SCOPES.RESTAURANT }),
  "onboarding.draft.edit": rule(lud(R.NEW, R.STORE, R.STORE_L), { scope: SCOPES.RESTAURANT }),
};
